<app-logged-out [noticeText]="noticeText"></app-logged-out>
